import React from 'react';
import { TabsContainer, Tab } from './CompetitorsStyles';

const tabs = [
  { id: 'overview', label: 'Resumen' },
  { id: 'comparison', label: 'Comparativa' },
  { id: 'strategy', label: 'Estrategia' },
  { id: 'monitoring', label: 'Monitoreo' },
  { id: 'history', label: 'Historial' },
];

const TabsNavigation = ({ activeTab, setActiveTab }) => (
  <TabsContainer>
    {tabs.map((tab, idx) => (
      <Tab
        key={tab.id}
        active={activeTab === tab.id}
        onClick={() => setActiveTab(tab.id)}
      >
        <span className="tab-index">{String(idx + 1).padStart(2, '0')}</span>
        {tab.label}
      </Tab>
    ))}
  </TabsContainer>
);

export default TabsNavigation;
